module.exports = __webpack_public_path__ + "media/packs/images/flags/BZ-ad959ca222dc6ad46517be94efdcf023.svg";